import { aadConfig, getAccessToken } from '@services/aad';
import axios from 'axios';

export type WebsiteInfo = {
  url?: string;
  title?: string;
  description?: string;
  locale?: string;
  type?: string;
  site_name?: string;
  image?: string;
  favicon?: string;
};

export const getWebsiteInfo = async (url: string): Promise<WebsiteInfo | null> => {
  await getAccessToken(aadConfig().accountScopes);
  try {
    const { data } = await axios.get<WebsiteInfo>(
      `${process.env.SUPPORT_HOST}/v1/websites/info?url=${encodeURIComponent(url)}`,
    );
    return data;
  } catch (err) {
    console.error('Failed to fetch website info', err);
    // DO NOTHING
    return null;
  }
};
